module.exports = __webpack_public_path__ + "img/QS.ea743b63.svg";